import { createContext, useContext } from 'react';

import type { CurrentUser, Role } from '@/features/auth/api';

export interface AuthState {
  user: CurrentUser | null;
  /** 初回の /auth/me 解決前 */
  isLoading: boolean;
  /** ログイン済みだが TOTP 検証が未了（事務局・スーパー管理者） */
  needsTotp: boolean;
  refresh: () => Promise<void>;
  signOut: () => Promise<void>;
  changeRole: (role: Role) => Promise<void>;
  setUser: (user: CurrentUser | null) => void;
}

export const AuthContext = createContext<AuthState | null>(null);

export function useAuth(): AuthState {
  const state = useContext(AuthContext);
  if (!state) {
    throw new Error('useAuth は AuthProvider の内側でのみ使えます');
  }
  return state;
}
